import { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { productCategories } from '@/mocks/products';

const ProductCategories = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.scroll-animate').forEach((child) => {
              child.classList.add('visible');
            });
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.08 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="categories" className="py-20 md:py-28 bg-brand-beige-light px-4 md:px-8" ref={ref}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14 scroll-animate">
          <span className="inline-block font-sans text-xs tracking-[0.25em] uppercase text-brand-olive font-medium mb-3">
            Explore Collections
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-brand-brown-dark font-bold mb-4">
            Explore Our Collections
          </h2>
          <div className="w-16 h-0.5 bg-brand-gold mx-auto mb-5"></div>
          <p className="font-sans text-brand-brown/70 max-w-xl mx-auto text-sm md:text-base">
            Every product range crafted with the same devotion to purity and traditional methods.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {productCategories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/products?category=${encodeURIComponent(cat.name)}`}
              className={`scroll-animate scroll-animate-delay-${(index % 4) + 1} group relative rounded-2xl overflow-hidden cursor-pointer ${
                index === 0 ? 'sm:col-span-2 lg:col-span-1 lg:row-span-1' : ''
              }`}
            >
              <div className="relative h-64 lg:h-72 w-full overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-brown-dark/80 via-brand-brown-dark/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-serif text-xl text-white font-semibold mb-1">
                    {cat.name}
                  </h3>
                  <p className="font-sans text-white/75 text-xs leading-relaxed">
                    {cat.description}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-brand-gold text-xs font-medium font-sans opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    Explore
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;
